import { AccountType, type User, type UserId } from "@/services/user/userTypes";

export const isOurAccount = (user: User): boolean => {
  return user.type === AccountType.Common;
};

export function assertUserIsLoggedIn(user: User | undefined): asserts user is User {
  if (user === undefined) {
    throw new Error("User is not logged in.");
  }
}

export function assertUserIdExists(userId: UserId | undefined): asserts userId is UserId {
  if (userId === undefined) {
    throw new Error("User ID is undefined.");
  }
}
